//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { focus } from '~/helpers/directives';
import SfIcon from '../../SfIcon.vue';
import SfButton from '../../SfButton/SfButton.vue';

export default {
  name: 'SfBottomNavigationItem',
  directives: { focus },
  components: {
    SfIcon,
    SfButton,
  },
  props: {
    icon: {
      type: [String, Array],
      default: '',
    },
    isActive: {
      type: Boolean,
      default: false,
    },
    iconActive: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    iconSize: {
      type: String,
      default: '20px',
    },
  },
  computed: {
    currentIcon() {
      return this.isActive && this.iconActive ? this.iconActive : this.icon;
    },
  },
};
